import * as React from 'react';
import { IAsidePanelContext } from './types';

export const AsidePanelContext = React.createContext<IAsidePanelContext>(null);
